<template>
  <div class="salary-manage">
    <div class="hd ly-card">
      <div class="fl">
        <el-button class="fl" type="primary">导出</el-button>
      </div>
      <div class="fr">
        <el-select v-model="searchFormData.year" placeholder="学年">
          <el-option
            v-for="item in years"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-select v-model="searchFormData.month" placeholder="月份">
          <el-option v-for="item in months" :key="item" :label="item + '月'" :value="item"></el-option>
        </el-select>
        <el-input v-model.trim="searchFormData.teacher_name" placeholder="教师姓名"></el-input>
        <el-button @click="search" type="primary">查询</el-button>
      </div>
    </div>
    <ly-table
      :tableHeader="tableHeader"
      :searchFormData="searchFormData"
      :tableConfig="tableConfig"
      :paginConfig="paginConfig"
      @pageChange="pageChange"
      class="ly-card"
      v-loading="loading"
      ref="lyTable"
    >
      <template v-slot:teacher_name="row">{{row.teacher_name}} / {{row.teacher_id_card_num}}</template>
      <template v-slot:class_fee="row">{{Decimal.mul(row.class_fee || 0, row.class_count || 0).toNumber()}}</template>
      <template v-slot:class_rate="row">{{row.class_rate | percent}}</template>
      <template v-slot:allSupFee="row">
        <el-button type="text" @click="e => openallSupFee(e, row)">{{ getMisAndSup(row)}}</el-button>
      </template>
      <template v-slot:action="row">
        <el-button type="text" v-if="row.class_id" size="small" @click="() => openInf(row)">生成</el-button>
      </template>
    </ly-table>
    <el-dialog title="生成工资单" :visible.sync="dialogVisible" class="create-salary" width="98%">
      <table class="native-table m-b-20">
        <tr>
          <th>班级名称</th>
          <th>班级部门</th>
          <th>项目名称</th>
          <th>课次</th>
          <th>单课费用</th>
          <th>学费收入</th>
          <th>课酬率</th>
          <th>班课酬</th>
          <th>总课酬</th>
          <th>代课/缺课</th>
          <th>其他</th>
          <th>月应发</th>
          <th>月实发</th>
          <th>总应发/总实发</th>
        </tr>
        <tr
          v-for="(item, index) in curTeachsalary.teacher_class_info"
          :key="`${item.class_id}${item.org_name}`"
        >
          <td>{{item.class_name}}</td>
          <td>{{item.org_name}}</td>
          <td>{{item.specialized_subject_name}}</td>
          <td>{{item.courses_count}}</td>
          <td>{{item.single_class_fee}}</td>
          <td>{{item.class_fee}}</td>
          <td>{{item.class_rate}}</td>
          <td>{{item.semester_remuneration}}</td>
          <td
            v-if="!index"
            :rowspan="index ? 0 : curTeachsalary.teacher_class_info.length"
          >{{totalFee}}</td>
          <td
            v-if="!index"
            :rowspan="index ? 0 : curTeachsalary.teacher_class_info.length"
          >{{getMisAndSup({index: curIndex})}}</td>
          <td>
            <el-input v-model.number="item.other" class="input-short"></el-input>
          </td>
          <td>{{item.current_month_remuneration}}</td>
          <td>{{getMonthReal(item)}}</td>
          <td
            v-if="!index"
            :rowspan="index ? 0 : curTeachsalary.teacher_class_info.length"
          >{{totalRealFee}}</td>
        </tr>
      </table>
      <strong>注意：金额单位（元）</strong>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="create">生成</el-button>
      </span>
    </el-dialog>
    <el-dialog title="代课/缺课详情" :visible.sync="feeDg" width="800px">
      <table class="native-table">
        <tr>
          <th>类型</th>
          <th>班级名称</th>
          <th>次数</th>
          <th>单次课费</th>
          <th>课酬率</th>
          <th>代/缺课老师</th>
          <th>总费用（元）</th>
        </tr>
        <tr v-for="(item, index) in feeMis" :key="item.id">
          <td v-if="!index" :rowspan="feeMis.length">缺课</td>
          <td>{{item.class_name}}</td>
          <td>{{item.miss_class_count}}</td>
          <td>{{getSingleFee(item)}}</td>
          <td>{{item.class_rate | percent}}</td>
          <td>{{originalData[curIndex].teacher_name}}</td>
          <td>- {{getSingleFee(item) * item.miss_class_count * item.class_rate}}</td>
        </tr>
        <tr v-for="(item, index) in feeUp" :key="item.id">
          <td v-if="!index" :rowspan="feeUp.length">代课</td>
          <td>{{item.name}}</td>
          <td>{{item.sup_count}}</td>
          <td>{{getSingleFee(item)}}</td>
          <td>{{item.remuneration | percent}}</td>
          <td>{{item.original_teacher_name}}</td>
          <td>+ {{getSingleFee(item) * item.sup_count * item.remuneration}}</td>
        </tr>
        <tr v-if="!feeUp.length && !feeMis.length">
          <td colspan="7">暂无数据</td>
        </tr>
      </table>
      <p>总计： <strong>{{supList[curIndex] - misList[curIndex]}} （元）</strong></p>
    </el-dialog>
  </div>
</template>

<script>
import {
  Dialog, Option, Input, Select
} from 'element-ui';
import LyTable from '@/components/LyTable';
import { salaryManageTable } from '@/utils/tableHeader';
import { finance } from '@/api';
import pattern from '@/utils/pattern';

const Decimal = require('decimal.js/decimal.js');

export default {
  name: 'SalaryManage',
  components: {
    LyTable,
    ElInput: Input,
    ElDialog: Dialog,
    ElSelect: Select,
    ElOption: Option
  },
  data() {
    return {
      Decimal,
      searchFormData: {
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
        teacher_name: ''
      },
      tableHeader: Object.freeze(salaryManageTable),
      searchFormConfig: {
        'label-width': '100px',
        'label-position': 'left',
        ref: 'ly-form',
        itemSpan: 24
      },
      tableConfig: {
        data: [],
        'span-method': ({ row, column }) => {
          if (
            column.property === 'teacher_name'
            || column.property === 'teacher_id_card_num'
            || column.type === 'index'
            || column.property === 'month'
            || column.property === 'action'
            || column.property === 'allSupFee'
          ) {
            if (typeof row.column === 'number') {
              return [row.column, 1];
            }
          }
          return [1, 1];
        }
      },
      paginConfig: {
        page_no: 1,
        page_size: 10,
        total: 0
      },
      originalData: [],
      loading: false,
      dialogVisible: false,
      years: [],
      months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      curTeachsalary: {
        teacher_class_info: []
      },
      curIndex: 0, // 弹窗列序号
      misList: {}, // 总缺课key - value(总值)
      supList: {}, // 总代课key - value(总值)
      supListData: {}, // 总代课key - value(列表详情)
      feeDg: false,
      feeMis: [],
      feeUp: []
    };
  },
  mounted() {
    this.search();
    this.$store.dispatch('schoolYear/getTermAndYearList').then(data => {
      if (data) {
        this.years = data.year;
      }
    });
  },
  filters: {
    percent(value) {
      return typeof value === 'number' ? `${Decimal.mul(value, 100).toNumber()} %` : '';
    }
  },
  computed: {
    totalFee() {
      return this.curTeachsalary.teacher_class_info.reduce(
        (total, value) => Decimal.add(total, value.semester_remuneration).toNumber(),
        0
      );
    },
    totalRealFee() {
      return this.curTeachsalary.teacher_class_info.reduce(
        (total, value) => Decimal.add(total, value.current_month_remuneration).add(pattern.decimal.test(value.other) ? value.other : 0).toNumber(),
        0
      );
    },
    getMisAndSup() {
      return row => {
        if (typeof row.index === 'number' && this.misList[row.index]) {
          return Decimal.sub(this.supList[row.index] || 0, this.misList[row.index]).toNumber();
        }
        return this.supList[row.index];
      };
    },
    getMonthReal() {
      return item => {
        if (item.other && pattern.decimal.test(item.other)) {
          return Decimal.add(item.other, item.current_month_remuneration).toNumber();
        }
        return item.current_month_remuneration;
      };
    },
    getSingleFee() {
      return item => Decimal.div(Decimal.mul(item.class_fee, item.class_count), item.courses_count).toNumber();
    }
  },
  methods: {
    reset() {
      this.misList = {}; // 总缺课key - value(总值)
      this.supList = {}; // 总代课key - value(总值)
      this.supListData = {}; // 总代课key - value(列表详情)
    },
    search() {
      this.reset();
      this.loading = true;
      finance
        .allTeacherSalary({
          ...this.searchFormData,
          page_no: this.paginConfig.page_no,
          page_size: this.paginConfig.page_size
        })
        .then(async res => {
          if (res && res.data) {
            const temp = [];
            for (let i = 0; i < res.data.list.length; i += 1) {
              const item = res.data.list[i];
              const curItem = JSON.parse(JSON.stringify(item));
              if (typeof curItem.agent_class_id_count_dict === 'string') {
                curItem.agent_class_id_count_dict = JSON.parse(curItem.agent_class_id_count_dict);
              }
              const class_id_list = Object.keys(curItem.agent_class_id_count_dict);
              // 总代课
              let allSupFee = 0;
              // 总缺课
              let allMisFee = 0;
              if (class_id_list.length) {
                // eslint-disable-next-line no-await-in-loop
                const classListRes = await finance.querySubstituteClass({
                  params: {
                    class_id_list
                  }
                });
                if (classListRes && classListRes.data && classListRes.data.class_info_list.length) {
                  this.supListData = {
                    [i]: classListRes.data.class_info_list.map(supItem => ({ ...supItem, sup_count: curItem.agent_class_id_count_dict[supItem.id] })),
                    ...this.supListData
                  };
                  classListRes.data.class_info_list.map(cur => {
                    const remuneration = typeof cur.remuneration === 'number' ? cur.remuneration : 1;
                    allSupFee = Decimal.add(
                      Decimal.mul(this.getSingleFee(cur), curItem.agent_class_id_count_dict[cur.id]).mul(remuneration),
                      allSupFee
                    ).toNumber();
                    return cur;
                  });
                }
              }
              const { teacher_class_info } = curItem;
              delete curItem.teacher_class_info;
              if (teacher_class_info && teacher_class_info.length) {
                teacher_class_info.map((value, index) => {
                  if (value.miss_class_count) {
                    const class_rate = typeof value.class_rate === 'number' ? value.class_rate : 1;
                    allMisFee = Decimal.add(
                      allMisFee,
                      Decimal.mul(value.miss_class_count, this.getSingleFee(value)).mul(class_rate)
                    ).toNumber();
                  }
                  if (index === 0) {
                    temp.push({
                      ...curItem,
                      ...value,
                      index: i,
                      column: teacher_class_info.length
                    });
                  } else {
                    temp.push({
                      ...value,
                      ...curItem,
                      index: i,
                      column: 0
                    });
                  }
                  return value;
                });
              } else {
                temp.push({
                  ...curItem,
                  index: i
                });
              }
              item.allMisFee = allMisFee;
              this.misList = {
                [i]: allMisFee,
                ...this.misList
              };
              this.supList = {
                [i]: allSupFee,
                ...this.supList
              };
            }
            this.tableConfig = {
              ...this.tableConfig,
              data: temp
            };
            this.paginConfig = {
              page_no: res.data.page_no,
              page_size: res.data.page_size,
              total: res.data.total
            };
            this.originalData = Object.freeze(res.data.list);
            this.loading = false;
          }
        });
    },
    openInf(row) {
      this.curIndex = row.index;
      this.originalData.map(item => {
        if (row.teacher_id === item.teacher_id) {
          const temp = JSON.parse(JSON.stringify(item));
          temp.teacher_class_info = temp.teacher_class_info.map(curItem => {
            const now = { ...curItem };
            now.month_real_salary = now.current_month_remuneration;
            now.other = 0;
            now.single_class_fee = Decimal.div(now.class_fee, now.courses_count).toNumber();
            return now;
          });
          this.curTeachsalary = temp;
        }
        return item;
      });
      this.dialogVisible = true;
    },
    create() {
      const teacher_class_info = this.curTeachsalary.teacher_class_info.map(item => ({
        class_id: item.class_id,
        study_fee_income: item.class_fee,
        remuneration_rate: item.class_rate,
        remuneration: Decimal.mul(item.class_fee, item.class_rate).toNumber(),
        supply_count: item.miss_class_count,
        other: item.other,
        month_remuneration: item.current_month_remuneration,
        month_real_salary: Decimal.add(item.other || 0, item.month_real_salary).toNumber()
      }));
      finance.createPayroll({
        params: {
          absent_and_miss_class_total_fee: this.getMisAndSup({ index: this.curIndex }),
          payroll_list: teacher_class_info,
          agent_class_json: this.curTeachsalary.agent_class_id_count_dict,
          month: this.curTeachsalary.month,
          year: this.searchFormData.year,
          teacher_id: this.curTeachsalary.teacher_id
        }
      }).then(res => {
        if (res) this.$message.success(res.msg || '生成成功！');
        this.dialogVisible = false;
      });
    },
    openallSupFee(e, row) {
      this.curIndex = row.index;
      this.feeUp = [];
      this.feeMis = [];
      // const fee = parseInt(e.target.innerText, 10);
      if (this.originalData[row.index].teacher_class_info) {
        this.feeMis = this.originalData[row.index].teacher_class_info.filter(item => item.miss_class_count);
      }
      this.feeUp = this.supListData[row.index] || [];
      this.feeDg = true;
    },
    pageChange({ page_size, page_no }) {
      this.paginConfig.page_no = page_no;
      this.paginConfig.page_size = page_size;
      this.search();
    }
  }
};
</script>

<style lang="less">
.salary-manage {
  .hd {
    overflow: hidden;
    .fr {
      > .el-input,
      > .el-select {
        width: 160px;
        margin-right: 20px;
      }
    }
    .ly-search-comp {
      display: inline-block;
      margin: auto 5px;
    }
  }
  .base-inf {
    list-style: none;
    li {
      float: left;
      overflow: hidden;
      margin: 10px;
      > span {
        font-weight: 600;
        display: inline-block;
        width: 100px;
        margin-right: 10px;
      }
      > i {
        font-style: normal;
        display: inline-block;
        min-width: 200px;
      }
    }
  }
  .el-table--enable-row-hover .el-table__body tr:hover>td {
    background-color: #fff;
  }
}
.create-salary {
  .input-short {
    width: 100px;
    padding: 10px;
  }
}
</style>
